import { MetricGrouping, MetricIntervalPeriod } from '@/types/agentEvents';
import { defaultOccupancyParams } from '@/utils/metricsParams';
import { shouldShowAgentPerformanceIntervalChart } from '@/utils/agentMetricIntervalView';
import {
  parseHHMMSSToSeconds,
  formatSecondsToHHMMSS,
} from '@/utils/metricsAggregate';
import { MetricsSection } from '../dashboard/MetricsSection';
import { MetricCard } from '../common/MetricCard';
import { IntervalMetricsChartWithSeries } from '../common/IntervalMetricsChartWithSeries';
import { MetricIntervalNumericLineChart } from '../common/MetricIntervalNumericLineChart';
import { api } from '@/store/api';
import { Box } from '@gapartners/ui';

export function AgentAverageWaitTimeSection() {
  return (
    <MetricsSection
      titleKey="metrics.averageWaitTime.title"
      descriptionKey="metrics.averageWaitTime.description"
      metricName="average-wait-time"
      defaultParams={{
        ...defaultOccupancyParams(),
        groupings: [MetricGrouping.AGENT],
        intervalPeriod: MetricIntervalPeriod.TOTAL,
      }}
      extraParams={{ targetSeconds: 20 }}
      useQuery={api.useGetAgentAverageWaitTimeMetricsQuery}
      groupingsOptions={[MetricGrouping.AGENT]}
      renderData={({ data, params, groupingKey }) => {
        const showIntervalChart = shouldShowAgentPerformanceIntervalChart(
          params.intervalPeriod,
          data
        );

        if (showIntervalChart) {
          return (
            <Box sx={{ width: '100%', minHeight: 300, mt: 1 }}>
              <IntervalMetricsChartWithSeries
                data={data}
                groupingKey={groupingKey}
                valueToNumber={parseHHMMSSToSeconds}
                valueFormatter={v =>
                  typeof v === 'string' ? v : formatSecondsToHHMMSS(Number(v))
                }
                height={300}
                IntervalChartComponent={MetricIntervalNumericLineChart}
              />
            </Box>
          );
        }

        return (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: 'repeat(2, 1fr)',
                lg: 'repeat(3, 1fr)',
                xl: 'repeat(5, 1fr)',
              },
              gap: 2,
            }}
          >
            {data.map(item => (
              <MetricCard
                key={item.id}
                title={item.dimensionLabels?.QUEUE ?? item.name ?? 'N/A'}
                value={String(item.value)}
              />
            ))}
          </Box>
        );
      }}
    />
  );
}
